import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import noAuth401 from "@/components/401"
import noAuth403 from "@/components/403"
import noFind404 from "@/components/404"
import error501 from "@/components/501"
import YHLogin from "@/components/login/index";
import ForgotPassword from '@/components/login/forgotpwd';
import HomePage from '@/components/home/home';
import ChangePassword from '@/components/login/changepwd';
import SysConfigList from '@/components/system/sysconfiglist';
import PointSetList from '@/components/ctlpoint/pointsetlist';
import OrgTree from '@/components/org/orgtree';
import SysUser from '@/components/system/sysuser';
import SysRole from '@/components/system/sysrole';
import DevList from '@/components/system/devlist';
import LocationList from '@/components/system/locationlist';
import CalcPointList from '@/components/system/calcpointlist';
import HisSetList from '@/components/his/hissetlist';
import ReportList from '@/components/report/reportlist';
import AirTime from '@/components/report/airtime';
import PointHistory from '@/components/his/pointhistory';
import AirTimeHour from '@/components/report/airtimehour';
import OffLine from '@/components/ctlpoint/offline';
import RealDev from '@/components/ctlpoint/realdevices';
import DevType from '@/components/ctlpoint/devtype';
import ChinaSchool from '@/components/map/chinaschool';
import LocTypeList from '@/components/ctlpoint/loctypelist';
import RechargeList from '@/components/ctlpoint/rechargelist';
import Privacy from '@/components/policy/privacy';

export default new Router({
	routes: [
		{
			path: "/",
			name: "Login",
			component: YHLogin,
			//props: route => ({
			//}),
			meta: {
				requireLogin: false,
				requireAuth: false
			}
		},
		{
			path: "/forgot",
			name: "ForgotPassword",
			component: ForgotPassword,
			//props: route => ({
			//}),
			meta: {
				requireLogin: false
			}
		},
		{
			path: "/privacy",
			name: "Privacy",
			component: Privacy,
			meta: {
				requireLogin: false
			}
		},
		{
			path: "/home",
			name: "Home",
			component: HomePage,
			//props: route => ({
			//}),
			meta: {
				requireLogin: true
			},
			redirect: '/pointsetlist',//页面默认加载的路由
			children: [
				{
					path: "/sysconfiglist",
					name: "sysconfiglist",
					component: SysConfigList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/pointsetlist",
					name: "pointsetlist",
					component: PointSetList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/orgtree",
					name: "orgtree",
					component: OrgTree,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/sysuser",
					name: "sysuser",
					component: SysUser,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/sysrole",
					name: "sysrole",
					component: SysRole,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/devlist",
					name: "devlist",
					component: DevList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/locationlist",
					name: "locationlist",
					component: LocationList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/calcpointlist",
					name: "calcpointlist",
					component: CalcPointList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/hissetlist",
					name: "hissetlist",
					component: HisSetList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/reportlist",
					name: "reportlist",
					component: ReportList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/airtime",
					name: "airtime",
					component: AirTime,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/airtimehour",
					name: "airtimehour",
					component: AirTimeHour,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/pointhistory",
					name: "pointhistory",
					component: PointHistory,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/offline",
					name: "offline",
					component: OffLine,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/realdev",
					name: "realdev",
					component: RealDev,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/devtype",
					name: "devtype",
					component: DevType,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/chinaschool",
					name: "chinaschool",
					component: ChinaSchool,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/loctypelist",
					name: "loctypelist",
					component: LocTypeList,
					meta: {
						requireLogin: true
					},
				},
				{
					path: "/rechargelist",
					name: "rechargelist",
					component: RechargeList,
					meta: {
						requireLogin: true
					}
				}
			]
		},
		{
			path: "/changpwd",
			name: "ChangePassword",
			component: ChangePassword,
			//props: route => ({
			//}),
			meta: {
				requireLogin: true
			}
		},
		{
			path: "/noAuth401",
			name: "noAuth401",
			component: noAuth401
		},
		{
			path: "/noAuth403",
			name: "noAuth403",
			component: noAuth403
		},
		{
			path: "/noFind404",
			name: "noFind404",
			component: noFind404
		},
		{
			path: "/error501",
			name: "error501",
			component: error501
		}
	]
});